const $ = jQuery.noConflict();

import AccordionDisciplines from './accordionDisciplines';

'use strict';
const JobsList = {
	/**
	 * @description Cache dom and strings
	 * @param {jQuery} $selectLocation
	 * @param {jQuery} $selectEmploymentType
	 * @param {jQuery} $selectDiscipline
	 * @param {jQuery} $disciplinesContainer
	 * @param {jQuery} $showAllDisciplinesCTA
	 * @param {jQuery} $loader
	 * @param {jQuery} $messageHolder
	 * @param {string|null} selectedLocation
	 * @param {string|null} selectedDiscipline
	 * @param {string|null} selectedEmploymentType
	 * @param {array} disciplinesInfo
	 * @param {boolean} firstAjax
	 * @param {array} icons
	 * @param {int} perPage
	 * @param {int} page
	 * @param {int} initialNumberOfDisciplines
	 * @param {bool} ajaxExecuting
	 */
	$selectLocation: $('.js-current-location'),
	$selectEmploymentType: $('.js-current-employment-type'),
	$selectDiscipline: $('.js-current-discipline'),
	$disciplinesContainer: $('.js-current-discipline-acc'),
	$mainContainer: $('.current-discipline'),
	$showAllDisciplinesCTA: $('.js-show-more-disciplines .btn'),
	$loader: $('.js-disciplines-loader'),
	$messageHolder: $('.disciplines-list__text-message-box'),
	firstAjax: true,
	selectedLocation: null,
	selectedDiscipline: null,
	selectedEmploymentType: null,
	disciplinesInfo: [],
	icons: [],
	perPage: 4,
	page: 1,
	initialNumberOfDisciplines: null,
	ajaxExecuting: false,

	/** @description Initialize class */
	init: function() {
		const _this = this;
		$(document).ready(function() {
			if (_this.$disciplinesContainer.length > 0) {
				_this.getDisciplinesAjax();
			}
		});

		this.$selectLocation.on('change', function(e) {
			_this.selectedLocation = $(e.target).find(':selected').val();
			_this.getDisciplinesAjax();
			_this.perPage = 4;
		});
		this.$selectDiscipline.on('change', function(e) {
			_this.selectedDiscipline = $(e.target).find(':selected').val();
			_this.getDisciplinesAjax();
			_this.perPage = 4;
		});
		this.$selectEmploymentType.on('change', function(e) {
			_this.selectedEmploymentType = $(e.target).find(':selected').val();
			_this.getDisciplinesAjax();
			_this.perPage = 4;
		});
	},

	/** @description Executes ajax request to retrieve disciplines for according to currently active time filter */
	getDisciplinesAjax: function() {
		const _this = this;
		if (!_this.ajaxExecuting) {
			$.ajax({
				type: 'POST',
				dataType: 'json',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'get-jobs',
					location: _this.selectedLocation,
					discipline: _this.selectedDiscipline,
					employmenttype: _this.selectedEmploymentType,
				},
				beforeSend: function() {
					_this.$loader.addClass('active');
					_this.$disciplinesContainer.addClass('active');
					_this.ajaxExecuting = true;
				},
				success: function(response) {
					if (response.data.disciplines) {
						_this.disciplinesInfo = response.data.disciplines;
						_this.icons = response.data.icons;
						if (_this.firstAjax) {
							_this.initialNumberOfDisciplines = response.data.disciplines.length;
						}
					} else {
						_this.disciplinesInfo = [];
					}
				},
				complete: function() {
					_this.$loader.removeClass('active');
					_this.$disciplinesContainer.removeClass('active');
					_this.afterDataUpdate();
					_this.ajaxExecuting = false;
					if (_this.perPage === 4 && _this.disciplinesInfo.length > 4) {
						_this.$showAllDisciplinesCTA.show();
					} else if (_this.perPage === _this.initialNumberOfDisciplines || _this.disciplinesInfo.length < 4) {
						_this.$showAllDisciplinesCTA.hide();
					}
				}
			});
		}
	},

	/** @description In charge of creating HTML for each discipline in list */
	appendHtml: function() {
		let htmlContent = '';
		for (let i = 0; i <= this.perPage - 1; i++) {
			if (this.disciplinesInfo[i]) {
				htmlContent +=
				`<div class="current-discipline__item js-current-discipline-acc-item">
				<div class="current-discipline__info">
					<div class="current-discipline__main-info">
						<h3 class="current-discipline__main-info-title">${this.disciplinesInfo[i].name}</h3>
						<span class="current-discipline__main-info-text current-discipline__main-info-time">
							${this.disciplinesInfo[i].employmentType}
						</span>
						<span class="current-discipline__main-info-text current-discipline__main-info-location">
							${this.icons.iconLocation}
							${this.disciplinesInfo[i].location}
						</span>
						<p class="current-discipline__main-info-link js-current-discipline-acc-btn" aria-label="Learn More link">
							Learn More
							${this.icons.iconDown}
						</p>
						<div class="current-discipline__details-btn-wrap">
							<a class="btn current-discipline__main-btn" href="${this.disciplinesInfo[i].permalink}" aria-label="Apply Button">
								<span>Apply</span>
							</a>
						</div>
					</div>
					<div class="current-discipline__details js-current-discipline-acc-details">
						<div class="current-discipline__details-content">
							<div class="current-discipline__details-name">
								<h2 class="current-discipline__details-title">Company Name:<span>${this.disciplinesInfo[i].companyName}</span></h2>
								<div class="current-discipline__details-salary">
									<h2>Salary Range:<span>${this.disciplinesInfo[i].salaryRange}</span></h2>
									<span class="current-discipline__details-salary-info">${this.disciplinesInfo[i].salaryExtraDetails}</span>
								</div>
							</div>
							<div class="current-discipline__details-entry-content">
								${this.disciplinesInfo[i].description}
							</div>
						</div>
					</div>
				</div>
			</div>`;
			}
		}

		if (htmlContent) {
			this.$disciplinesContainer.show();
			this.$messageHolder.removeClass('disciplines-list__text-message-box--active');
		} else {
			this.$disciplinesContainer.hide();
			this.$messageHolder.addClass('disciplines-list__text-message-box--active');
		}

		this.$disciplinesContainer.html(htmlContent);
	},

	/** @description Creates pagination and appends it to disciplines container */
	appendLoadMore: function() {
		const _this = this;
		const numOfDisciplines = this.disciplinesInfo.length;
		if(numOfDisciplines > 4) {
			$('.js-show-more-disciplines').show().css('display', 'flex');
			this.$showAllDisciplinesCTA.on('click', function() {
				_this.perPage = _this.initialNumberOfDisciplines;
				_this.getDisciplinesAjax();
			});
		}
	},

	/**
	 * @description Actions to execute after data has been updated:
	 * - append html for each discipline
	 * - init disciplines for accordions
	 * - create pagination
	 * - scroll to top of holder
	 */
	afterDataUpdate: function() {
		this.appendHtml();
		AccordionDisciplines.initDisciplines();
		this.appendLoadMore();
		if (!this.firstAjax) {
			// $('html, body').animate({
			// 	scrollTop: this.$mainContainer.offset().top - 30
			// }, 350);
		} else {
			this.firstAjax = false;
		}
	},
};

export default JobsList;
